export default [
    {
        key: "ksm__ogranichitel",
        allArray: "allTableStops",
        activeArray: "activeTableStops",
        position: "bottom",
    },
    {
        key: "ksm__polka_nizhnyaya__dsp",
        allArray: "allShelfDownSide",
        activeArray: "activeShelfDownSide",
        position: "bottom",
    },
    {
        key: "ksm__lotok_dlya_provodov",
        allArray: "allLotokDlyaProvodov",
        activeArray: "activeLotokDlyaProvodov",
        position: "bottom",
    },
    {
        key: "ksm__lotok_metallicheskii",
        allArray: "allLotokMetallicheskii",
        activeArray: "activeLotokMetallicheskii",
        position: "top",
    },
    {
        key: "ksm__planka_dlya_lotkov",
        allArray: "allPlankaDlyaLotkov",
        activeArray: "activePlankaDlyaLotkov",
        position: "top",
    },
    {
        key: "ksm__polka",
        allArray: "allPolkaPribornayaKSM",
        activeArray: "activePolkaPribornayaKSM",
        position: "top",
    },
    {
        key: "ksm__perfopanel",
        allArray: "allPerfopanelKSM",
        activeArray: "activePerfopanelKSM",
        position: "top",
    },
];
